
import * as handlebars_family from "../handlebars_family.js";
import "../widget/action-menu.js";
const TPL = handlebars_family.addTemplate("list/tasklist_head",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "background-image:url('"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"firstMedia") : depth0)) != null ? lookupProperty(stack1,"pictureUrl") : stack1), depth0))
    + "');";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "background-color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + ";";
},"5":function(container,depth0,helpers,partials,data) {
    return " <div class=\"fw-localveil\"></div> ";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div style=\"position:absolute;right:0;bottom:0;height:140px;width:140px;\"> "
    + ((stack1 = lookupProperty(helpers,"if-eq").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"taskListType") : depth0),"SHOPPING_LIST",{"name":"if-eq","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":1,"column":297},"end":{"line":1,"column":594}}})) != null ? stack1 : "")
    + " </div> ";
},"8":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"list.create_list_cover_illustration_type_groceries",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":337},"end":{"line":1,"column":401}}}))
    + " ";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if-eq").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"taskListType") : depth0),"TODOS",{"name":"if-eq","hash":{},"fn":container.program(11, data, 0),"inverse":container.program(13, data, 0),"data":data,"loc":{"start":{"line":1,"column":411},"end":{"line":1,"column":583}}})) != null ? stack1 : "")
    + " ";
},"11":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"list.create_list_cover_illustration_type_todo",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":443},"end":{"line":1,"column":502}}}))
    + " ";
},"13":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"list.create_list_cover_illustration_type_other",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":512},"end":{"line":1,"column":572}}}))
    + " ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"fw-todoHead hidden-print\" style=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"firstMedia") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":46},"end":{"line":1,"column":158}}})) != null ? stack1 : "")
    + "\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"firstMedia") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":1,"column":161},"end":{"line":1,"column":609}}})) != null ? stack1 : "")
    + " <div style=\"position:absolute;top:16px;left:16px;width:56px;font-size:16px;color:#fff\" class=\"phone-only hidden-print\" data-fw-onclick=\"goback\"><icon>"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_arrow_left",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":760},"end":{"line":1,"column":787}}}))
    + "</icon></div><div style=\"position:absolute;bottom:16px;left:0px;font-size:20px;font-weight:500;color:#fff\"><icon style=\"margin:auto 16px;\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"iconsimple") : depth0), depth0)) != null ? stack1 : "")
    + "</icon><i>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</i></div><icon style=\"position:absolute;top:16px;right:16px;border-radius:50%;background:var(--fwSurface)\" data-widget=\"widget/action-menu\" data-key=\"tasklistitemmenu\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_more_vertical",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":1133},"end":{"line":1,"column":1163}}}))
    + "</icon></div><flexrow class=\"print-only\" style=\"line-height:32px;border-bottom:var(--border);margin-bottom:16px;padding-bottom:8px;\"><icon style=\"width:56px;\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"iconsimple") : depth0), depth0)) != null ? stack1 : "")
    + "</icon><i>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</i></flexrow>";
},"useData":true});
export default TPL;